<template>
  <div>
    <el-radio-group style="margin-bottom: 7px;" v-model="period">
      <el-radio label="N">한번만</el-radio>
      <el-radio label="D">매일</el-radio>
      <el-radio label="W">매주</el-radio>
      <el-radio label="M">매월</el-radio>
    </el-radio-group>

    <el-row v-show="period === 'N'" type="flex" justify="start">
      <el-col>
        <div class="title-popup-s">스케줄 실행 날짜</div>
        <el-date-picker v-model="onceData.scheduleStarttime" type="date" placeholder="스케줄 실행 날짜" :picker-options="{ disabledDate }" @change="checkValidationTimeInfo"/>
      </el-col>
      <el-col>
        <w-ams-time-selection-component class="title-popup-s" ref="onceTime" title="실행 시간" :is-once-time-info="true" :executeHour="onceData.scheduleHour" :executeMinute="onceData.scheduleMinute" @change-time-info="changeTimeInfo"/>
      </el-col>
    </el-row>

    <el-row v-show="period === 'N' && isOnceValidationFlag === true">
      <span class="el-form-item__error">현재보다 과거 일시는 선택할 수 없습니다.</span>
    </el-row>

    <div v-show="period === 'D'">
      <w-ams-time-selection-component class="title-popup-s" ref="dailyTime" title="스케줄 실행 시간" :executeHour="dailyData.scheduleHour" :executeMinute="dailyData.scheduleMinute" />
    </div>

    <div class="setting-checkbox" v-show="period === 'W'">
      <el-row style="margin-bottom: 20px">
        <div class="title-popup-s">스케줄 실행 요일</div>
        <el-checkbox-group style="margin-bottom: 20px;" v-show="weeklyData.scheduleIntervalDate.length > 0" v-model="weeklyData.scheduleIntervalDate">
          <el-checkbox-button v-for="day in WEEK" :key="day.week" :label="(day.week+1).toString()">{{day.label}}</el-checkbox-button>
        </el-checkbox-group>
      </el-row>
      <w-ams-time-selection-component ref="weeklyTime" title="실행 시간" :executeHour="weeklyData.scheduleHour" :executeMinute="weeklyData.scheduleMinute" />
    </div>

    <div v-show="period === 'M'">
      <el-row style="margin-bottom: 20px" type="flex" justify="start">
        <el-col>
          <div class="title-popup-s">스케줄 실행 월 주기 (1월 부터)</div>
          <el-select v-model="monthlyData.scheduleIntervalMonth" collapse-tags placeholder="월">
            <el-option v-for="month in MONTH_INTERVAL" :key="month" :label="month" :value="month.toString()" />
          </el-select>
          <span>개월</span>
        </el-col>
        <el-col>
          <div class="title-popup-s">스케줄 실행 일</div>
          <el-select v-model="monthlyData.scheduleIntervalDate" collapse-tags placeholder="일">
            <el-option v-for="date in 31" :key="date" :label="date" :value="date.toString()" />
            <el-option key="L" label="마지막날" value="L" />
          </el-select>
        </el-col>
      </el-row>
      <w-ams-time-selection-component ref="monthlyTime" title="실행 시간" :executeHour="monthlyData.scheduleHour" :executeMinute="monthlyData.scheduleMinute" />
    </div>
  </div>
</template>

<script>
import sortBy from 'lodash/sortBy';
import keys from 'lodash/keys';
import clone from 'lodash/clone';

import { WEEK } from '@/constants/date';
import WAmsTimeSelectionComponent from './AmsTimeSelectionComponent';

const onceInitData = {
  scheduleStarttime: new Date(),
  scheduleHour: 0,
  scheduleMinute: 0,
};
const dailyInitData = {
  scheduleHour: 0,
  scheduleMinute: 0,
};
const weeklyInitData = {
  scheduleIntervalDate: ['1', '2', '3', '4', '5', '6', '7'],
  scheduleHour: 0,
  scheduleMinute: 0,
};
const monthlyInitData = {
  scheduleIntervalMonth: '1',
  scheduleIntervalDate: '1',
  scheduleHour: 0,
  scheduleMinute: 0,
};

export default {
  name: 'WAmsPeriodSettingComponent',
  components: {
    WAmsTimeSelectionComponent,
  },
  data() {
    return {
      WEEK,
      MONTH_INTERVAL: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      period: 'N',
      onceData: {},
      dailyData: {
        scheduleIntervalHour: [],
      },
      weeklyData: {
        scheduleIntervalDate: [],
      },
      monthlyData: {},
      isOnceValidationFlag: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.isOnceValidationFlag = false;
      this.period = 'N';
      this.onceData = clone(onceInitData);
      this.dailyData = clone(dailyInitData);
      this.weeklyData = clone(weeklyInitData);
      this.monthlyData = clone(monthlyInitData);
      this.$refs.onceTime.init();
      this.$refs.dailyTime.init();
      this.$refs.weeklyTime.init();
      this.$refs.monthlyTime.init();
    },
    /**
     * 주기 설정 데이터를 리턴한다.
     * @return {[type]} [description]
     * @author jda
     */
    getPeriodSettingData() {
      const schedulePeriod = this.period;
      if (schedulePeriod === 'N') {
        const selectionTime = this.$refs.onceTime.getSelectionTime();
        const starttime = new Date(this.onceData.scheduleStarttime);
        starttime.setHours(selectionTime.hour, selectionTime.minute, 0, 0);

        return {
          schedulePeriod,
          scheduleStarttime: starttime.getTime(),
        };
      } else if (schedulePeriod === 'D') {
        const selectionTime = this.$refs.dailyTime.getSelectionTime();

        return {
          schedulePeriod,
          scheduleHour: selectionTime.hour,
          scheduleMinute: selectionTime.minute,
        };
      } else if (schedulePeriod === 'W') {
        const selectionTime = this.$refs.weeklyTime.getSelectionTime();

        return {
          schedulePeriod,
          scheduleIntervalDate: sortBy(this.weeklyData.scheduleIntervalDate, (interval) => parseInt(interval, 10)).toString(),
          scheduleHour: selectionTime.hour,
          scheduleMinute: selectionTime.minute,
        };
      } else if (schedulePeriod === 'M') {
        const selectionTime = this.$refs.monthlyTime.getSelectionTime();
        const monthlyData = this.monthlyData;

        return {
          schedulePeriod,
          scheduleIntervalMonth: sortBy(monthlyData.scheduleIntervalMonth, (interval) => parseInt(interval, 10)).toString(),
          scheduleIntervalDate: sortBy(monthlyData.scheduleIntervalDate, (interval) => parseInt(interval, 10)).toString(),
          scheduleHour: selectionTime.hour,
          scheduleMinute: selectionTime.minute,
        };
      }
      return true;
    },
    /**
     * 수집 주기 편집에서 주기 설정 데이터를 바인딩한다.
     * @param  {[type]} record [description]
     * @author jda
     */
    setPeriodSettingData(record) {
      const schedulePeriod = record.schedulePeriod;
      this.period = schedulePeriod;

      if (schedulePeriod === 'N') {
        const scheduleStarttime = record.scheduleStarttime;
        const starttime = new Date(scheduleStarttime);
        this.onceData = {
          scheduleStarttime,
          scheduleHour: starttime.getHours(),
          scheduleMinute: starttime.getMinutes(),
        };
      } else if (schedulePeriod === 'D') {
        this.dailyData = {
          scheduleHour: record.scheduleHour,
          scheduleMinute: record.scheduleMinute,
        };
      } else if (schedulePeriod === 'W') {
        this.weeklyData = {
          scheduleIntervalDate: record.scheduleIntervalDate.split(','),
          scheduleHour: record.scheduleHour,
          scheduleMinute: record.scheduleMinute,
        };
      } else if (schedulePeriod === 'M') {
        this.monthlyData = {
          scheduleIntervalMonth: record.scheduleIntervalMonth.split(','),
          scheduleIntervalDate: record.scheduleIntervalDate.split(','),
          scheduleHour: record.scheduleHour,
          scheduleMinute: record.scheduleMinute,
        };
      }
    },
    /**
     * 주기에 해당하는 각 key들을 리턴한다.
     * 수집 주기 편집시 사용.
     * @param  {[type]} period [description]
     * @return {[type]}        [description]
     * @author jda
     */
    getKeysByPeriod(period) {
      if (period === 'N') {
        return keys(this.onceData);
      } else if (period === 'D') {
        return keys(this.dailyData);
      } else if (period === 'W') {
        return keys(this.weeklyData);
      } else if (period === 'M') {
        return keys(this.monthlyData);
      }
      return true;
    },
    /**
     * 주기 설정 데이터를 cron표현식으로 변환한다.
     * @author jeee12
     * @return {[type]} [description]
     */
    getPeriodSettingDataByCronExpression() {
      let cronExpression = '';
      const schedulePeriod = this.period;
      if (schedulePeriod === 'N') {
        const selectionTime = this.$refs.onceTime.getSelectionTime();
        const starttime = new Date(this.onceData.scheduleStarttime);
        starttime.setHours(selectionTime.hour, selectionTime.minute, 0, 0);

        cronExpression = `0 ${selectionTime.minute} ${selectionTime.hour} ${starttime.getDate()} ${starttime.getMonth() + 1} ? ${starttime.getFullYear()}`;
      } else if (schedulePeriod === 'D') {
        const selectionTime = this.$refs.dailyTime.getSelectionTime();

        cronExpression = `0 ${selectionTime.minute} ${selectionTime.hour} * * ?`;
      } else if (schedulePeriod === 'W') {
        const selectionTime = this.$refs.weeklyTime.getSelectionTime();
        const scheduleIntervalDate = sortBy(this.weeklyData.scheduleIntervalDate, (interval) => parseInt(interval, 10)).toString();

        cronExpression = `0 ${selectionTime.minute} ${selectionTime.hour} ? * ${scheduleIntervalDate} *`;
      } else if (schedulePeriod === 'M') {
        const selectionTime = this.$refs.monthlyTime.getSelectionTime();
        const monthlyData = this.monthlyData;

        cronExpression = `0 ${selectionTime.minute} ${selectionTime.hour} ${monthlyData.scheduleIntervalDate} 1/${monthlyData.scheduleIntervalMonth} ? *`;
      }
      return cronExpression;
    },
    /**
     * cron표현식을 변환하여 주기 설정 데이터로 바인딩한다.
     * @author jeee12
     * @param  {[type]} record [description]
     */
    setPeriodSettingDataByCronExpression(record) {
      const cronExpression = record.scheduleExpression;
      const cron = cronExpression.split(' ');
      const second = cron[0];
      const minutes = cron[1];
      const hours = cron[2];
      const dayOfMonth = cron[3];
      const month = cron[4];
      const dayOfWeek = cron[5];
      const year = cron[6];
      let period = 'N';

      if (dayOfMonth.indexOf('*') > -1) {
        period = 'D';
      } else if (month.indexOf('*') > -1) {
        period = 'W';
      } else if (year.indexOf('*') > -1) {
        period = 'M';
      }
      this.period = period;

      if (period === 'N') {
        const starttime = new Date(`${year}-${month}-${dayOfMonth} ${hours}:${minutes}:${second}`);
        this.onceData = {
          scheduleStarttime: starttime.getTime(),
          scheduleHour: Number(hours),
          scheduleMinute: Number(minutes),
        };
      } else if (period === 'D') {
        this.dailyData = {
          scheduleHour: Number(hours),
          scheduleMinute: Number(minutes),
        };
      } else if (period === 'W') {
        this.weeklyData = {
          scheduleIntervalDate: dayOfWeek.split(','),
          scheduleHour: Number(hours),
          scheduleMinute: Number(minutes),
        };
      } else if (period === 'M') {
        this.monthlyData = {
          scheduleIntervalMonth: month.split('/')[1],
          scheduleIntervalDate: dayOfMonth,
          scheduleHour: Number(hours),
          scheduleMinute: Number(minutes),
        };
      }
      this.checkValidationTimeInfo();
    },
    /**
     * 한번만 수행되는 태스크는 현재 시점에서 미래인 경우만 가능하다.
     * @author yelim
     */
    disabledDate(datetime) {
      const currentTime = new Date();
      const compareDate = new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate(), 0, 0, 0);
      return datetime < compareDate;
    },
    /**
     * timeSelection에서 선택한 시간이 onceData에 바인딩한다.
     * @author yelim
     * @param  {[type]} timeInfo [description]
     * @return {[type]}          [description]
     */
    changeTimeInfo(timeInfo) {
      const schedulePeriod = this.period;
      if (schedulePeriod === 'N') {
        const selectDate = this.onceData.scheduleStarttime;
        this.onceData = {
          scheduleStarttime: selectDate,
          scheduleHour: timeInfo.hour,
          scheduleMinute: timeInfo.minute,
        };
        this.checkValidationTimeInfo();
      }
    },
    /**
     * 스케쥴 설정 조건이 한번만인 경우에 대해 과거일시를 선택할 수 없도록 유효성 검사
     * @author yelim
     * @return {[type]} [description]
     */
    checkValidationTimeInfo() {
      const schedulePeriod = this.period;
      if (schedulePeriod === 'N') {
        const currentDate = new Date();
        const currentTime = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), currentDate.getHours(), currentDate.getMinutes(), 0);
        const onceDataInfo = this.onceData;
        // 현재 캘린더에 설정된 시간
        const selectionDate = new Date(onceDataInfo.scheduleStarttime);
        // 현재 캘린더에 설정된 시간 + timeSelection 컴포넌트에 설정된 시간
        const compareTime = new Date(selectionDate.getFullYear(), selectionDate.getMonth(), selectionDate.getDate(), onceDataInfo.scheduleHour, onceDataInfo.scheduleMinute, 0);
        if (currentTime > compareTime) {
          this.isOnceValidationFlag = true;
        } else {
          this.isOnceValidationFlag = false;
        }
      } else {
        this.isOnceValidationFlag = false;
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/AmsSettings/TriggerSetting/components/AmsPeriodSettingComponent.vue